import type {} from '@mui/x-date-pickers/themeAugmentation';
import type {} from '@mui/x-data-grid-premium/themeAugmentation';

import { inputsCustomizations } from './customizations/inputs';
import { feedbackCustomizations } from './customizations/feedback';
import { surfacesCustomizations } from './customizations/surfaces';
import { dataGridCustomizations } from './customizations/dataGrid';
import { navigationCustomizations } from './customizations/navigation';
import { dataDisplayCustomizations } from './customizations/dataDisplay';
import { datePickersCustomizations } from './customizations/datePickers';
import { colorSchemes, typography, shadows, shape } from './themePrimitives';

const theme = {
  cssVariables: {
    colorSchemeSelector: 'data-mui-color-scheme',
    cssVarPrefix: 'template',
  },
  colorSchemes,
  typography,
  shadows,
  shape,
  components: {
    ...inputsCustomizations,
    ...dataDisplayCustomizations,
    ...feedbackCustomizations,
    ...navigationCustomizations,
    ...surfacesCustomizations,
    ...dataGridCustomizations,
    ...datePickersCustomizations,
  },
};

export default theme;
